<!-- 多功能上传组件 -->
<!--  zpy 2023-2-10  上传组件如果设置可以同时上传多个文件，则不能修改fileList，否则on-progress 会获取不到第二上传的文件信息导致报错-->
<!--  多文件上传时不能在before-upload获取上传服务器令牌，否则上传第二个文件时获取新的令牌会导致之前的令牌失效，因获取令牌和上传接口用时不一致，会导致上传成功但是服务器没有存储(现在服务器后台没有返回信息，无法判断) -->
<template>
  <div>
    <el-upload
      action="https://fleetan-hk-bucket.oss-accelerate.aliyuncs.com"
      ref="multiFunUpload"
      :data="dataObj"
      :list-type="showListType"
      :multiple="true"
      :limit="maxCount"
      :on-exceed="handleExceed"
      :accept="uploadType"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
      :on-progress="handleProgress"
      :on-success="handleUploadSuccess"
      :on-preview="handlePreview"
      :on-error="handleError"
    >
      <el-button size="small" @click="handleClickUpload" type="primary">{{btnName}}</el-button>
      <div v-if="fileList.length == 0" slot="tip" class="el-upload__tip">{{btnTips}}</div>
    </el-upload>
  </div>
</template>
<script>
import { policy } from "./policy";
import { createUniqueString } from "@/utils/index";

export default {
  name: "multiFunctionalUpload",
  props: {
    // 上传按钮提示文字 非必传
		tipText:{
			type: String,
			default:'上传文件-可上传多个文件'
		},
    // 上传文件类型 传空则不限制文件类型
    fileType:{
      type: String,
      default:'',
    },
    // 上传文件最大数量 不传则默认单个文件
    fileCount:{
      type: Number,
      default: 1,
    },
    // 已上传文件预览样式 不传默认文本类型
    listType:{
      type:String,
      default: 'text',
    },
		preFile: {
      type:Array,
      default:[],
    },
  },
	watch:{
		//监听按钮名称和提示文字
		'tipText':{
			handler(newValue){
        this.btnName = newValue.split('-')[0];
        this.btnTips = newValue.split('-')[1];
			},
			immediate: true,
		},
    'fileType':{
    	handler(value){
        switch(value){
          case 'img': this.uploadType = '.jpg, .png';break;
          case 'excl': this.uploadType = '.xls, .xlsx';break;
          case 'pdf': this.uploadType = '.pdf';break;
					default: this.uploadType = '';
        }
    	},
    	immediate: true,
    },
    'fileCount':{
      handler(value){
        this.maxCount = value;
      },
      immediate: true,
    },
    'listType':{
      handler(value){
        // text 、picture、picture-card
        this.showListType = value;
      },
      immediate: true,
    },

    //监听预览文件，有值显示在fileList中
    preFile:{
    	handler(newValue){
    		this.fileList = [];
        this.uploadList = [];
    		if(newValue.length > 0){
    			newValue.forEach(item => {
    				this.fileList.push({
              name:item.name,
              url:item.url
            })
    			})
          this.uploadList = newValue
    		}
    	},
    	immediate: true,
    }
	},
  computed: {
  },
  data() {
    return {
      dataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
      },
      btnName:'',
      btnTips:'',
      maxCount:10, // 上传文件数量
      uploadType:'',//上传文件类型
      showListType:'',// 上传预览文件样式
      fileList:[],
      uploadList:[],
      // getTokenLoading:true,
    };
  },
  methods: {

    // 点击上传
    handleClickUpload(){
      this.getToken();
    },
    // 获取令牌
    getToken(){
      let _self = this;
      new Promise((resolve, reject) => {
        policy()
          .then(response => {
            _self.dataObj.policy = response.policy;
            _self.dataObj.signature = response.signature;
            _self.dataObj.ossaccessKeyId = response.accessid;
            _self.dataObj.key =
              response.dir + createUniqueString() + "~${filename}";
            _self.dataObj.dir = response.dir;
            _self.dataObj.host = response.host;
            // _self.getTokenLoading = false;
            // console.log(_self.dataObj);
            // resolve(true);
          })
          .catch(err => {
            // console.log('error');
            // reject(false);
            _self.$message.error('获取令牌失败，请重新刷新页面')
          });
      });
    },

    emitInput(fileList,type) {
      if(type == 1){//上传
        this.$message.success("上传成功...");
      }else{//删除

      }
      this.$emit("input", fileList);
    },
    handleRemove(file, fileList) {
      this.uploadList.forEach((item,index) => {
        if(item.name == file.name){
          this.uploadList.splice(index,1);
        }
      })
			this.emitInput(this.uploadList,2);
    },
    handlePreview(file) {
      this.uploadList.forEach(item => {
        if(item.name == file.name){
          window.open(item.url, "_blank");
        }
      })
    },
    beforeUpload(file) {
      this.$message({
        message: "正在上传，请稍后",
        typpe: "warning"
      });
      return true;
    },
    // 上传完成
    handleUploadSuccess(res, file,fileList) {
      // this.fileList = fileList;
			let fileName = file.name;
			let url = this.dataObj.host + "/" + this.dataObj.key.replace("${filename}", fileName)
			this.uploadList.push({
				name:fileName,
				url:url
			})
      this.emitInput(this.uploadList,1);
    },
    handleProgress(event,file,fileList){
      // console.log(fileList);
    },
    handleExceed(files, fileList) {
      this.$message({
        message: "最多只能上传" + this.maxCount + "个文件",
        type: "warning",
        duration: 1000
      });
    },
    // 上传失败
    handleError(err,file,fileList){
      this.$message.error('Upload File Failed ! Please Upload Again.')
      // this.getToken();
    },
    // 清除上传列表
    clearFileList(){
      this.$refs.multiFunUpload.clearFiles()
    },
  },
  created() {
    // this.getToken();
  }
};
</script>
<style>
</style>
